import React from 'react';
import { useNavigate } from 'react-router-dom';
import './books.css';
import LoadingSpinner from '../../../utility/LoadingSpinner';

function Bookscard({ book_img_url, title, id, poem_content, price }) {
  const navigate = useNavigate();


  // if (!book_img_url || !title || !poem_content || !price) return null;

  const handleClick = () => {
    localStorage.setItem("selectedPoem", JSON.stringify({ title, id, poem_content, price }));
    navigate(`/billing`);
  };

  return (
    <div className="poem-card">
      <img src={book_img_url} alt="book image" className="poem-card__image" />
      <h3 className="poem-card__price">{price}</h3>
      <div>
        <button className="poem-card__button1" onClick={handleClick}>
          Buy Now
        </button>
      </div>
      <p
        className="poem-card__description"
        dangerouslySetInnerHTML={{ __html: poem_content }}
      />
    </div>
  );
}

export default Bookscard;
